const accounting = require('accounting');

const fields = [
  {
    key: "code",
    label: "Mã cổ phiếu ",
    thStyle: "width: 180px;vertical-align: middle;",
    stickyColumn: true,
    isRowHeader: true,
    type:"code",
    group:4,
    check: true,
    value:[]
  },
  {
    order: "1",
    label: "Sàn",
    key: "San",
    unit: "",
    thStyle: {width: "90px"},
    type:"code",
    group:4,
    check: true,
    value:[]
  },
  {
    order: "2",
    label: "Ngành hàng",
    key: "NganhHang",
    unit: "",
    thStyle: {width: "120px"},
    check: true,
  },
  {
    order: "3",
    label: "Vốn Hóa Thị Trường",
    key: "VonHoaThiTruong",
    unit: "Tỷ VND",
    type: "text",
    group: 2,
    lt: null,
    gt: null,
    control: "><",
    controlText: "Ở giữa",
    check: true,
    formatter: val => accounting.toFixed(val/1e9, 2)
  },
  {
    order: "4",
    label: "Quy Mô Vốn Hóa",
    key: "QuyMoVonHoa",
    unit: "",
    check: true,
  },
  {
    order: "5",
    label: "Doanh Thu 4 Quý",
    key: "DoanhThu4Quy",
    unit: "Tỷ VND",
    check: true,
  },
  {
    order: "6",
    label: "TT Doanh Thu 4 Quý",
    key: "TTDoanhThu4Quy",
    unit: "%",
    group: 1,
    lt: null,
    gt: null,
    control: "><",
    controlText: "Ở giữa",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "7",
    label: "TT Doanh Thu Quý Gần Nhì",
    key: "TTDoanhThuQuyGanNhi",
    unit: "%",
    group: 1,
    lt: null,
    gt: null,
    control: "><",
    controlText: "Ở giữa",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "8",
    label: "TT Doanh Thu Quý Gần Nhất",
    key: "TTDoanhThuQuyGanNhat",
    unit: "%",
    group: 1,
    lt: null,
    gt: null,
    control: "><",
    controlText: "Ở giữa",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "9",
    label: "Lợi Nhuận Sau Thuế 4 Quý",
    key: "LoiNhuanSauThue4Quy",
    unit: "Tỷ VND",
    check: true,
  },
  {
    order: "10",
    label: "TT Lợi Nhuận Sau Thuế 4 Quý",
    key: "TTLoiNhuanSauThue4Quy",
    unit: "%",
    group: 1,
    lt: null,
    gt: null,
    control: "><",
    controlText: "Ở giữa",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "11",
    label: "TT Lợi Nhuận Sau Thuế Quý Gần Nhì",
    key: "TTLoiNhuanSauThueQuyGanNhi",
    unit: "%",
    group: 1,
    lt: null,
    gt: null,
    control: "><",
    controlText: "Ở giữa",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "12",
    label: "TT Lợi Nhuận Sau Thuế Quý Gần Nhất",
    key: "TTLoiNhuanSauThueQuyGanNhat",
    unit: "%",
    group: 1,
    lt: null,
    gt: null,
    control: "><",
    controlText: "Ở giữa",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "13",
    label: "Tỷ Lệ Lãi Gộp",
    key: "TyLeLaiGop",
    unit: "%",
    group: 2,
    lt: null,
    gt: null,
    control: "><",
    controlText: "Ở giữa",
    check: true,
    formatter: val => accounting.toFixed(val, 2)

  },
  {
    order: "14",
    label: "TT TL Lãi Gộp 4 Quý",
    key: "TTTLLaiGop4Quy",
    unit: "%",
    group: 1,
    lt: null,
    gt: null,
    control: "><",
    controlText: "Ở giữa",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "15",
    label: "TT TL Lãi Gộp Quý Gần Nhất",
    key: "TTTLLaiGopQuyGanNhat",
    unit: "%",
    group: 1,
    lt: null,
    gt: null,
    control: "><",
    controlText: "Ở giữa",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "16",
    label: "Tỷ Lệ Lãi Ròng",
    key: "TyLeLaiRong",
    unit: "%",
    group: 2,
    lt: null,
    gt: null,
    control: "><",
    controlText: "Ở giữa",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "17",
    label: "TT TL Lãi Ròng 4 Quý",
    key: "TTTLLaiRong4Quy",
    unit: "%",
    group: 1,
    lt: null,
    gt: null,
    control: "><",
    controlText: "Ở giữa",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "18",
    label: "TT TL Lãi Ròng Quý Gần Nhất",
    key: "TTTLLaiRongQuyGanNhat",
    unit: "%",
    group: 1,
    lt: null,
    gt: null,
    control: "><",
    controlText: "Ở giữa",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "19",
    label: "ROE",
    key: "ROE",
    unit: "%",
    group: 2,
    lt: null,
    gt: null,
    control: "><",
    controlText: "Ở giữa",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "20",
    label: "TT ROE 4 Quý",
    key: "TTROE4Quy",
    unit: "%",
    group: 2,
    lt: null,
    gt: null,
    control: "><",
    controlText: "Ở giữa",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "21",
    label: "TT ROE Quý Gần Nhất",
    key: "TTROEQuyGanNhat",
    unit: "%",
    group: 1,
    lt: null,
    gt: null,
    control: "><",
    controlText: "Ở giữa",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "22",
    label: "ROA",
    key: "ROA",
    unit: "%",
    group: 2,
    lt: null,
    gt: null,
    control: "><",
    controlText: "Ở giữa",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "23",
    label: "TT ROA 4 Quý",
    key: "TTROA4Quy",
    unit: "%",
    group: 1,
    lt: null,
    gt: null,
    control: "><",
    controlText: "Ở giữa",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "24",
    label: "TT ROA Quý Gần Nhất",
    key: "TTROAQuyGanNhat",
    unit: "%",
    group: 1,
    lt: null,
    gt: null,
    control: "><",
    controlText: "Ở giữa",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "25",
    label: "EPS",
    key: "EPS",
    unit: "VNĐ/CP",
    group: 2,
    lt: null,
    gt: null,
    control: "><",
    controlText: "Ở giữa",
    check: true,
    formatter: val => accounting.toFixed(val, 0)
  },
  {
    order: "26",
    label: "Tăng Trưởng EPS 4 Quý",
    key: "TangTruongEPS4Quy",
    unit: "%",
    group: 1,
    lt: null,
    gt: null,
    control: "><",
    controlText: "Ở giữa",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "27",
    label: "Tăng Trưởng EPS Quý Gần Nhì",
    key: "TangTruongEPSQuyGanNhi",
    unit: "%",
    group: 1,
    lt: null,
    gt: null,
    control: "><",
    controlText: "Ở giữa",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "28",
    label: "Tăng Trưởng EPS Quý Gần Nhất",
    key: "TangTruongEPSQuyGanNhat",
    unit: "%",
    group: 1,
    lt: null,
    gt: null,
    control: "><",
    controlText: "Ở giữa",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "29",
    label: "P/E",
    key: "PE",
    unit: "Lần",
    group: 2,
    lt: null,
    gt: null,
    control: "><",
    controlText: "Ở giữa",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "30",
    label: "P/B",
    key: "PB",
    unit: "Lần",
    group: 2,
    lt: null,
    gt: null,
    control: "><",
    controlText: "Ở giữa",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "31",
    label: "Giá Trị Công Ty",
    key: "GiaTriCongTy",
    unit: "Tỷ VND",
    check: true,
    formatter: val => accounting.toFixed(val/1e3, 0)
  },
  {
    order: "32",
    label: "Định giá CI",
    key: "DinhGiaCI",
    unit: "VNĐ/CP",
    check: true,
    formatter: val => accounting.toFixed(val, 0)
  },
  {
    order: "33",
    label: "LÃI VỐN",
    key: "LaiVon",
    unit: "%",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "34",
    label: "Dòng Tiền Cổ Tức",
    key: "DongTienCoTuc",
    unit: "%",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "35",
    label: "Tăng Giá Trị",
    key: "TangGiaTri",
    unit: "%",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "36",
    label: "TỔNG LỢI ÍCH",
    key: "TongLoiIch",
    unit: "",
    check: true,
  },
  {
    order: "37",
    label: "CORE 4 Quý Doanh Thu",
    key: "Core4QuyDoanhThu",
    unit: "%",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "38",
    label: "CORE 4 Quý Lợi Nhuận",
    key: "Core4QuyLoiNhuan",
    unit: "%",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "39",
    label: "CORE 1 Quý Doanh Thu",
    key: "Core1QuyDoanhThu",
    unit: "%",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "40",
    label: "CORE 1 Quý Lợi Nhuận",
    key: "Core1QuyLoiNhuan",
    unit: "%",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "41",
    label: "Cổ Tức Công Bố Bằng Tiền",
    key: "CoTucCongBoBangTien",
    unit: "%",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "42",
    label: "Cổ Tức Công Bố Bằng Cổ Phiếu",
    key: "CoTucCongBoCoPhieu",
    unit: "%",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "43",
    label: "Tổng Cổ Tức Công Bố",
    key: "TongCoTucCongBo",
    unit: "%",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "44",
    label: "BEST",
    key: "BEST",
    unit: "Nhóm Ngành",
    check: true,
  },
  {
    order: "45",
    label: "TL Nội Bộ Mua Ròng 3 Tháng",
    key: "TLNoiBoMuaRong3Thang",
    unit: "%",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "46",
    label: "TL Nội Bộ Mua Ròng 1 Tháng",
    key: "TLNoiBoMuaRong1Thang",
    unit: "%",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },

  {
    order: "47",
    label: "Lượng Cổ Phiếu Freeloat",
    key: "LuongCoPhieuFreeloat",
    unit: "Cổ phiếu",
    check: true,
  },
  {
    order: "48",
    label: "Tỷ Lệ Cổ Phiếu Freeloat",
    key: "TyleCoPhieuFreeloat",
    unit: "%",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "49",
    label: "Vốn Hóa Cổ Phiếu Freeloat",
    key: "VonHoaCoPhieuFreeloat",
    unit: "Tỷ VNĐ",
    check: true,
  },

  {
    order: "50",
    label: "TL Nước Ngoài <br> Mua Ròng 3 Tháng",
    key: "TLNuocNgoaiMuaRong3Thang",
    unit: "%",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "51",
    label: "TL Nước Ngoài Mua Ròng 1 Tháng",
    key: "TLNuocNgoaiMuaRong1Thang",
    unit: "%",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "52",
    label: "Giá Trị Nước Ngoài <br> Mua Ròng 1 Tháng",
    key: "GiaTriNuocNgoaiMuaRong1Thang",
    unit: "Tỷ VND",
    check: true,
  },
  {
    order: "53",
    label: "Room Nước Ngoài Được Mua",
    key: "RoomNuocNgoaiDuocMua",
    unit: "Cổ phiếu",
    check: true,
    formatter: val => accounting.toFixed(val, 4)
  },

  {
    order: "54",
    label: "Vốn Hóa Nước Ngoài<br>  Được Mua",
    key: "VonHoaNuocNgoaiDuocMua",
    unit: "Tỷ VNĐ",
    check: true,
  },
  {
    order: "55",
    label: "Kế Hoạch Doanh Thu<br>  Tăng Trưởng",
    key: "KeHoachDoanhThuTangTruong",
    unit: "%/Năm",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "56",
    label: "Kế Hoạch LNTT<br>  Tăng Trưởng",
    key: "KeHoachLNTTTangTruong",
    unit: "%/Năm",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "57",
    label: "Kế Hoạch LNST<br>  Tăng Trưởng",
    key: "KeHoachLNSTTangTruong",
    unit: "%/Năm",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "58",
    label: "Kế Hoạch Tăng Trưởng <br>Tổng Quan",
    key: "KeHoachTangTruongTongQuan",
    unit: "%/Năm",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "59",
    label: "Kinh Doanh Liên Tục<br>  Có Lãi",
    key: "KinhDoanhLienTucCoLai",
    unit: "Năm",
    check: true,
  },
  {
    order: "59",
    label: "Tổng Nợ / Vốn<br>  Chủ Sở Hữu",
    key: "TongNoVonChuSoHuu",
    unit: "Lần",
    group: 2,
    lt: null,
    gt: null,
    control: "><",
    controlText: "Ở giữa",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "60",
    label: "TT Tổng Nợ / VCSH<br>  4 Quý",
    key: "TTTongNoVCSH4Quy",
    unit: "%",
    group: 1,
    lt: null,
    gt: null,
    control: "><",
    controlText: "Ở giữa",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "63",
    label: "TT Tổng Nợ / VCSH<br>  Quý Gần Nhất",
    key: "TTTongNoVCSHQuyGanNhat",
    unit: "%",
    group: 1,
    lt: null,
    gt: null,
    control: "><",
    controlText: "Ở giữa",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "64",
    label: "Nợ Dài Hạn / Lợi<br>  Nhuận Sau Thuế",
    key: "NoDaiHanLoiNhuanSauThue",
    unit: "Lần",
    group: 2,
    lt: null,
    gt: null,
    control: "><",
    controlText: "Ở giữa",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "65",
    label: "TT Nợ Dài Hạn / LNST<br>  4 Quý",
    key: "TTNoDaiHanLNST4Quy",
    unit: "%",
    group: 1,
    lt: null,
    gt: null,
    control: "><",
    controlText: "Ở giữa",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "66",
    label: "TT Nợ Dài Hạn / LNST<br>  Quý Gần Nhất",
    key: "TTNoDaiHanLNSTQuyGanNhat",
    unit: "%",
    group: 1,
    lt: null,
    gt: null,
    control: "><",
    controlText: "Ở giữa",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "67",
    label: "Tài Sản Ngắn Hạn / Nợ<br>  Ngắn Hạn Hiện Thời",
    key: "TaiSanNganHanNoNganHanHienThoi",
    unit: "%",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "68",
    label: "Tài Sản Ngắn Hạn / Vốn<br>  Hóa Hiện Thời",
    key: "TaiSanNganHanVonHoaHienThoi",
    unit: "%",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "69",
    label: "Doanh Thu / Chi Phí<br>  Quản Lý Tổng Quát",
    key: "DoanhThuChiPhiQuanLyTongQuat",
    unit: "Lần",
    group: 2,
    lt: null,
    gt: null,
    control: "><",
    controlText: "Ở giữa",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "70",
    label: "TT Doanh Thu / CP<br>  QLTQ 4 Quý",
    key: "TTDoanhThuCPQLTQ4Quy",
    unit: "%",
    group: 1,
    lt: null,
    gt: null,
    control: "><",
    controlText: "Ở giữa",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "71",
    label: "LNST / Chi Phí<br>  Quản Lý Tổng Quát",
    key: "LNSTChiPhiQuanLyTongQuat",
    unit: "Lần",
    group: 2,
    lt: null,
    gt: null,
    control: "><",
    controlText: "Ở giữa",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "72",
    label: "TT LNST / CP<br>  QLTQ 4 Quý",
    key: "TTLNSTCPQLTQ4Quy",
    unit: "%",
    group: 1,
    lt: null,
    gt: null,
    control: "><",
    controlText: "Ở giữa",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "73",
    label: "Khối Lượng Khớp Lệnh<br>  Hiện Tại",
    key: "KhoiLuongKhopLenhHienTai",
    unit: "Nghìn CP",
    group: 3,
    lt: null,
    gt: null,
    control: "><",
    controlText: "Ở giữa",
    check: true,
    formatter: val => accounting.toFixed(val/1e3, 2)
  },
  {
    order: "74",
    label: "Đột Biến Khối Lượng<br>  So Ngày Liền Trước",
    key: "DotBienKhoiLuongSoNgayLienTruoc",
    unit: "%",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "75",
    label: "TB Khối Lượng Khớp Lệnh<br>  10 Ngày",
    key: "TBKhoiLuongKhopLenh10Ngay",
    unit: "Nghìn CP",
    check: true,
  },
  {
    order: "76",
    label: "Đột Biến Khối Lượng<br>  So TB 10 Ngày",
    key: "DotBienKhoiLuongSoTB10Ngay",
    unit: "%",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "77",
    label: "TB Giá Trị Khớp Lệnh<br>  10 Ngày",
    key: "TBGiaTriKhopLenh10Ngay",
    unit: "Tỷ VNĐ",
    check: true,
  },
  // {
  //   order: "78",
  //   label: "Đột Biến Giá Trị Khớp<br>  So TB 10 Ngày",
  //   key: "DotBienGiaTriKhopSoTB10Ngay",
  //   unit: "%"
  // },
  {
    order: "79",
    label: "Giá Cổ Phiếu",
    key: "GiaCoPhieu",
    unit: "VNĐ/CP",
    group: 3,
    lt: null,
    gt: null,
    control: "><",
    controlText: "Ở giữa",
    check: true,
    formatter: val => accounting.formatMoney(val, "",0)
  },
  {
    order: "80",
    label: "Đột Biến Giá<br>  So Ngày Liền Trước",
    key: "DotBienGiaSoNgayLienTruoc",
    unit: "%",
    group: 3,
    lt: null,
    gt: null,
    control: "><",
    controlText: "Ở giữa",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "81",
    label: "Giá Cổ Phiếu<br>  So Với MA20",
    key: "GiaCoPhieuSoVoiMA20",
    unit: "",
    group: 3,
    lt: null,
    gt: null,
    type: "vs",
    span1:"Giá cổ phiếu hiện tại",
    span2:"Đường trung bình 20 ngày (MA20)",
    control:null,
    check: true,
  },
  {
    order: "82",
    label: "Giá Cổ Phiếu<br>  So Với MA50",
    key: "GiaCoPhieuSoVoiMA50",
    unit: "",
    group: 3,
    lt: null,
    gt: null,
    type: "vs",
    span1:"Giá cổ phiếu hiện tại",
    span2:"Đường trung bình 50 ngày (MA50)",
    control:null,
    check: true,
  },
  {
    order: "83",
    label: "Giá Cổ Phiếu<br>  So Với MA150",
    key: "GiaCoPhieuSoVoiMA150",
    unit: "",
    group: 3,
    lt: null,
    gt: null,
    type: "vs",
    span1:"Giá cổ phiếu hiện tại",
    span2:"Đường trung bình 150 ngày (MA150)",
    control:null,
    check: true,
  },
  {
    order: "84",
    label: "Giá Cổ Phiếu<br>  So Với MA250",
    key: "GiaCoPhieuSoVoiMA250",
    unit: "",
    group: 3,
    lt: null,
    gt: null,
    type: "vs",
    span1:"Giá cổ phiếu hiện tại",
    span2:"Đường trung bình 250 ngày (MA250)",
    control:null,
    check: true,
  },
  {
    order: "85",
    label: "MA20 vs MA50",
    key: "MA20vsMA50",
    unit: "",
    group: 3,
    lt: null,
    gt: null,
    type: "vs",
    span1:"Trung bình 20 ngày",
    span2:"Trung bình 50 ngày",
    control:null,
    check: true,
  },
  {
    order: "86",
    label: "MA20 vs MA150",
    key: "MA20vsMA150",
    unit: "",
    group: 3,
    lt: null,
    gt: null,
    type: "vs",
    span1:"Trung bình 20 ngày",
    span2:"Trung bình 150 ngày",
    control:null,
    check: true,
  },
  {
    order: "87",
    label: "MA20 vs MA250",
    key: "MA20vsMA250",
    unit: "",
    group: 3,
    lt: null,
    gt: null,
    type: "vs",
    span1:"Trung bình 20 ngày",
    span2:"Trung bình 250 ngày",
    control:null,
    check: true,
  },
  {
    order: "88",
    label: "MA50 vs MA150",
    key: "MA50vsMA150",
    unit: "",
    group: 3,
    lt: null,
    gt: null,
    type: "vs",
    span1:"Trung bình 50 ngày",
    span2:"Trung bình 150 ngày",
    control:null,
    check: true,
  },
  {
    order: "89",
    label: "MA50 vs MA250",
    key: "MA50vsMA250",
    unit: "",
    group: 3,
    lt: null,
    gt: null,
    type: "vs",
    span1:"Trung bình 50 ngày",
    span2:"Trung bình 250 ngày",
    control:null,
    check: true,
  },
  {
    order: "90",
    label: "MA150 vs MA250",
    key: "MA150vsMA250",
    unit: "",
    group: 3,
    lt: null,
    gt: null,
    type: "vs",
    span1:"Trung bình 150 ngày",
    span2:"Trung bình 250 ngày",
    control:null,
    check: true,
  },
  {
    order: "91",
    label: "Tăng Trưởng MA20",
    key: "TangTruongMA20",
    unit: "",
    group: 3,
    lt: null,
    gt: null,
    control: "><",
    controlText: "Ở giữa",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "92",
    label: "Tăng Trưởng MA50",
    key: "TangTruongMA50",
    unit: "",
    group: 3,
    lt: null,
    gt: null,
    control: "><",
    controlText: "Ở giữa",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "93",
    label: "Tăng Trưởng MA150",
    key: "TangTruongMA150",
    unit: "",
    group: 3,
    lt: null,
    gt: null,
    control: "><",
    controlText: "Ở giữa",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "94",
    label: "Tăng Trưởng MA250",
    key: "TangTruongMA250",
    unit: "",
    group: 3,
    lt: null,
    gt: null,
    control: "><",
    controlText: "Ở giữa",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "95",
    label: "TAM TỤ",
    key: "TamTu",
    unit: "",
    group: 3,
    lt: null,
    gt: null,
    control: "><",
    controlText: "Ở giữa",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "96",
    label: "Trạng Thái Biểu Đồ",
    key: "TrangThaiBieuDo",
    unit: "",
    check: true,
  },
  {
    order: "97",
    label: "Cường Độ Dòng Tiền<br>  Ngắn Hạn",
    key: "CuongDoDongTienNganHan",
    unit: "",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "98",
    label: "Cường Độ Dòng Tiền<br>  Trung Hạn",
    key: "CuongDoDongTienTrungHan",
    unit: "",
    check: true,
    formatter: val => accounting.toFixed(val, 2)
  },
  {
    order: "99",
    label: "ĐIỂM SỐ CI",
    key: "DiemSoCI",
    unit: "",
    check: true,
  },
  {
    order: "100",
    label: "TIÊU CHÍ Z",
    key: "TieuChiZ",
    check: true,
  },
  { key: "setup", label: "",check: true ,thStyle: {width: "50px"}},
]

module.exports = fields;
